import { render } from "./SBPBulkInvoiceReport.vue?vue&type=template&id=c847fc2a&scoped=true"
import script from "./SBPBulkInvoiceReport.vue?vue&type=script&lang=js"
export * from "./SBPBulkInvoiceReport.vue?vue&type=script&lang=js"

import "./SBPBulkInvoiceReport.vue?vue&type=style&index=0&id=c847fc2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c847fc2a"]])

export default __exports__